export interface TreatmentSessionLog {
  id: string;
  studentId: string;
  studentName: string;
  rollId: string;
  moduleKey: string;
  moduleName: string;
  therapistName: string;
  sessionDate: string;
  durationMins: number;
  status: 'ACTIVE_SESSION' | 'COMPLETED' | 'PENDING_SOAP';
  scoreAchieved: string;
  treatmentObservation: string;
  cptCode?: string;
}

export const INITIAL_TREATMENT_AUDIT_LOGS: TreatmentSessionLog[] = [
  {
    id: 'LOG-2026-001',
    studentId: '1',
    studentName: 'Master Rahul Sharma',
    rollId: 'STU-2026-001',
    moduleKey: 'aac',
    moduleName: '01. AAC Speech Synthesizer',
    therapistName: 'Sarah Jenkins (SLP)',
    sessionDate: '2026-08-02 10:30 AM',
    durationMins: 45,
    status: 'COMPLETED',
    scoreAchieved: '92% AAC Phrase Accuracy',
    treatmentObservation: 'Rahul successfully built 4-word core phrases using symbol grid. Token stars awarded.',
    cptCode: 'CPT 92507 (Speech Therapy)'
  },
  {
    id: 'LOG-2026-002',
    studentId: '2',
    studentName: 'Miss Ananya Kulkarni',
    rollId: 'STU-2026-002',
    moduleKey: 'speech-therapy',
    moduleName: '02. Speech & Articulation',
    therapistName: 'Michael Chen (OT)',
    sessionDate: '2026-08-02 11:15 AM',
    durationMins: 30,
    status: 'ACTIVE_SESSION',
    scoreAchieved: '92% Articulation Precision',
    treatmentObservation: 'Ongoing /r/ initial sound repetition drills with audio frequency matching.',
    cptCode: 'CPT 92507 (Speech Therapy)'
  },
  {
    id: 'LOG-2026-003',
    studentId: '3',
    studentName: 'Master Aarav Patel',
    rollId: 'STU-2026-003',
    moduleKey: 'hydrotherapy',
    moduleName: '21. Hydrotherapy Aquatic Rehab',
    therapistName: 'Priya Nair (PT)',
    sessionDate: '2026-08-02 02:00 PM',
    durationMins: 60,
    status: 'COMPLETED',
    scoreAchieved: '60% Buoyancy Gait Mastery',
    treatmentObservation: 'Completed 50m gait walk in 34.5°C hydrotherapy pool with 60% buoyancy support.',
    cptCode: 'CPT 97110 (Physical Therapy)'
  },
  {
    id: 'LOG-2026-004',
    studentId: '4',
    studentName: 'Miss Diya Sengupta',
    rollId: 'STU-2026-101',
    moduleKey: 'sign-language',
    moduleName: '04. Sign Language & Gestures',
    therapistName: 'Sarah Jenkins (SLP)',
    sessionDate: '2026-08-02 09:00 AM',
    durationMins: 40,
    status: 'COMPLETED',
    scoreAchieved: '48/50 ISL Signs Recognized',
    treatmentObservation: 'Diya identified 48 ISL video flashcards with zero prompts.',
    cptCode: 'CPT 92507 (Speech Therapy)'
  },
  {
    id: 'LOG-2026-005',
    studentId: '8',
    studentName: 'Master Vikram Joshi',
    rollId: 'STU-2026-105',
    moduleKey: 'gamified-neuro',
    moduleName: '29. WebGL Biofeedback Neuro-Rehab',
    therapistName: 'Dr. Robert Vance (MD)',
    sessionDate: '2026-08-02 03:30 PM',
    durationMins: 35,
    status: 'ACTIVE_SESSION',
    scoreAchieved: '320ms Reaction Latency',
    treatmentObservation: 'Neuro-rehab game target tracking session in progress at Bed 302-A.',
    cptCode: 'CPT 97530 (Cognitive Rehab)'
  }
];
